import React from 'react';
import sapLogo from '../../Assets/images/sap-logo.png';
import styles from './SapBadge.module.scss';

const SapBadge = ({ className = '' }) => (
  <img
    src={sapLogo}
    alt="Logo officiel Services à la personne"
    className={`${styles.badge} ${className}`.trim()}
  />
);

export default SapBadge;
